import { render, staticRenderFns } from "./getCabinet.vue?vue&type=template&id=7e642080&"
import script from "./getCabinet.vue?vue&type=script&lang=js&"
export * from "./getCabinet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports